
import React, { useState, useRef } from 'react';
import { BASE_URL } from '../config';

const ChatInput = ({ options, inputType, onSend, isLoading }) => {
  const [textInput, setTextInput] = useState('');
  const fileInputRef = useRef(null);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${BASE_URL}/api/v1/chat/upload`, {
        method: 'POST',
        credentials: 'include',
        body: formData
      });
      
      const data = await response.json();
      // onSend('', data.imageUrl);
      onSend('', {
        fullUrl: data.imageUrl,
        rawPath: data.imagePath
      });
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if ((inputType === 'text' && (textInput.trim() || fileInputRef.current.files.length > 0)) || 
        inputType === 'options')  {
      onSend(textInput);
      setTextInput('');
        fileInputRef.current.value = '';
    }
  };

  return (
    <div className="border-t border-gray-200 p-4 bg-white">
          {inputType === 'options' ? (
        <div className="flex flex-col gap-2 mb-6">
        
          
          {/* Button Grid - ALWAYS shows 2 columns even on mobile */}
          <div className="grid grid-cols-2 gap-2">
            {/* First two buttons */}
            {options?.slice(0, 2).map((option) => (
              <button
                key={option.text}
                onClick={() => onSend(option.text)}
                disabled={isLoading}
                className={`
                  w-full px-2 py-1 text-[11px]
                  sm:px-3 sm:py-1.5 sm:text-sm
                  bg-white border border-blue-500 
                        rounded-md text-gray-800 shadow-[0_4px_12px_rgba(59,130,246,0.25)]
                   transition-transform transform hover:scale-[1.02]
                  disabled:opacity-50
                   text-center
                  flex items-center justify-center
                  min-h-[36px] max-h-[60px] overflow-auto
                `}
              >
                <span className="break-words">
                  {option.text}
                </span>
              </button>
            ))}
          </div>

          {/* Third button (if exists) - centered below */}
          {options?.length === 3 && (
            <div className="flex justify-center pt-2">
              <button
                onClick={() => onSend(options[2].text)}
                disabled={isLoading}
                className={`
                  w-1/2 px-2 py-1 text-[11px]
                   sm:px-3 sm:py-1.5 sm:text-sm  
                   bg-white border border-blue-500 
                   rounded-md text-gray-800 shadow-[0_4px_12px_rgba(59,130,246,0.25)]
                  transition-transform transform hover:scale-[1.02]
                  disabled:opacity-50
                  text-center
                  flex items-center justify-center
                  min-h-[36px] max-h-[60px] overflow-auto
                `}
              >
                <span className="break-words">
                  {options[2].text}
                </span>
              </button>
            </div>
          )}
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex gap-2 w-full">
          <div className="flex items-center flex-shrink-0">
            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              className="p-2 text-gray-500 hover:text-gray-700"
              disabled={isLoading}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageUpload}
              className="hidden"
              accept="image/*"
            />
          </div>

          <input
            type="text"
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
            placeholder="Type your message..."
            className="flex-1 min-w-0 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            disabled={isLoading}
          />
          <button
            type="submit"
            disabled={isLoading || (!textInput.trim() && !fileInputRef.current?.files?.length)}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors disabled:opacity-50 flex-shrink-0"
          >
            Send
          </button>
        </form>
      )}
    </div>
  );
};

export default ChatInput;